import { render, staticRenderFns } from "./AM65Less.vue?vue&type=template&id=1b964629&scoped=true"
import script from "./AM65Less.vue?vue&type=script&lang=ts"
export * from "./AM65Less.vue?vue&type=script&lang=ts"
import style0 from "./AM65Less.vue?vue&type=style&index=0&id=1b964629&prod&lang=scss&scoped=true"
import style1 from "./AM65Less.vue?vue&type=style&index=1&id=1b964629&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b964629",
  null
  
)

export default component.exports